import React, { Component } from "react"
import { connect } from "react-redux"
import { GridSize } from "@material-ui/core/Grid"

import DocumentTableHeader from "./DocumentTableHeader"
import DocumentTableBody from "./DocumentTableBody"
import { PeopleFlowCombinedReducer } from "../../../store"
import { ColorPalette } from "../../../config/colors"
import { IFileMeta } from "../../../interfaces"
import { DocTableColumnConfig } from "../../../types"

import "../../../assets/css/scrollbar.css"

interface DocumentTableState {
  allSelected: boolean
  height: number
}

interface DocumentTableProps {
  style?: React.CSSProperties | undefined
  scrollContainerStyle?: React.CSSProperties | undefined
  tableWidth: GridSize
  columnConfig?: DocTableColumnConfig
  folderSelectionEnabled?: boolean
  selectedFolders?: string[] | []
  expandedFolders: string[]
  data: Record<string, IFileMeta[]>
  emptyFolderIconColor?: string
  hideMetaData?: boolean
  selectionEnabled?: boolean
  selectedRole: string
  noHeader?: boolean
  folderSelectionHandler?: (folder: string) => void
  onToolbarClicked: (id: string) => void
  onDocClicked?: (docname: string) => void
  expandCollapseFolder: (folder: string) => void
  onSelectAll?: (selectAllState: boolean) => void
}

class DocumentTable extends Component<DocumentTableProps, DocumentTableState> {
  state: DocumentTableState = {
    allSelected: false,
    height: window.innerHeight,
  }

  onDocClicked(docname: string) {
    if (this.props.onDocClicked === undefined) {
      return
    }
    this.props.onDocClicked(docname)
  }

  onSelectAll() {
    if (!this.props.onSelectAll) {
      return
    }
    const { allSelected } = this.state
    this.props.onSelectAll(!allSelected)
    this.setState({ allSelected: !allSelected })
  }

  render() {
    let header = null
    if (!this.props.noHeader) {
      header = (
        <DocumentTableHeader
          tableWidth={this.props.tableWidth}
          columnConfig={this.props.columnConfig as DocTableColumnConfig}
          selectionEnabled={this.props.selectionEnabled}
          onClick={(id: string) => this.props.onToolbarClicked(id)}
          onSelectAll={() => this.onSelectAll()}
        />
      )
    }
    // if (this.props.selectedRole === 'AUDITOR') {
    //   // 1. prevent doc download through button (right click and save as still possible as well as taking screenshots)
    //   // 2. prevent doc deletion
    //   columnConfig.splice(2, 1)
    // }
    return (
      <div
        style={{
          ...styles.tableContainer,
          ...this.props.style,
          display: "flex",
          flexDirection: "column",
        }}>
        {header}
        <div
          style={{
            height: this.state.height * 0.7,
            maxHeight: this.state.height * 0.7,
            overflow: "scroll",
            paddingBottom: 200,
          }}>
          <DocumentTableBody
            tableWidth={this.props.tableWidth}
            folderContents={this.props.data}
            expandedFolders={this.props.expandedFolders}
            folderSelectionEnabled={this.props.folderSelectionEnabled}
            selectedFolders={this.props.selectedFolders}
            folderSelectionHandler={this.props.folderSelectionHandler}
            expandCollapseFolder={this.props.expandCollapseFolder}
            onDocClicked={(docname) => this.onDocClicked(docname)}
            emptyFolderIconColor={this.props.emptyFolderIconColor}
            hideMetaData={this.props.hideMetaData}
          />
        </div>
      </div>
    )
  }
}

const styles = {
  tableContainer: {
    width: "100%",
  },
  iconStyle: {
    color: ColorPalette.CARD_WHITE,
    width: "1.1rem",
    height: "1.1rem",
    marginRight: 10,
    marginLeft: 10,
  },
}

const mapStateToProps = (state: PeopleFlowCombinedReducer) => {
  return {
    selectedRole: state.sessionManager.selectedRole,
  }
}

export default connect(mapStateToProps)(DocumentTable)
